module.exports = __webpack_public_path__ + "static/media/nosotros04.28a5c543.jpg";